var map = {
	"./Polipos.png": 92372,
	"./Reconexiones intestinales.png": 64493,
	"./absecos anorrectales.png": 66552,
	"./apendicitis.png": 48986,
	"./cancer-de-colon.png": 8059,
	"./colitis.png": 26413,
	"./condiloma.png": 34145,
	"./diverticulitis.png": 39039,
	"./dolor-anal.png": 28187,
	"./estomas.png": 9598,
	"./fisura-anal.png": 39246,
	"./fístulas anales.png": 17852,
	"./hemorroides.png": 19936,
	"./hernia-abdominal.png": 21491,
	"./hernia-inguinal.png": 32348,
	"./hernia-umbilical.png": 78677,
	"./incontingencia-fecal.png": 79953,
	"./intestino-inflamacion.png": 45085,
	"./piedras vesicula.png": 96283,
	"./prolapso-rectal.png": 98467,
	"./prurito-anal.png": 87364,
	"./quiste.png": 64815,
	"./recto-vaginal.png": 46161,
	"./sangrado intestinal.png": 60325,
	"./urgencias quirúrgicas.png": 5296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69624;